import Button from "@/components/atom/Button";
import Input from "@/components/atom/Input";
import { revalidateCustom, updateProfileSaya } from "@/functions/databaseData";
import handleErrorAPI from "@/functions/handleErrorAPI";
import useAlert from "@/functions/useAlert";
import { EyeOffSvg, EyeOnSvg, PenEditSvg } from "@/public/svg";
import { signOut } from "next-auth/react";
import { usePathname } from "next/navigation";
import phone from "phone";
import React, { useState } from "react";
import { toast } from "react-toastify";

const settingToast = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

export default function InfoAKunPengiriman({
  handleChange,
  profile,
  forms,
  errors,
  handleChangeError,
  setErrors,
  token,
}) {
  const path = usePathname()
  const { showAlert } = useAlert();
  const [hidePw, setHidePw] = useState(true);
  const [disable, setDisable] = useState({
    infoAkun: true,
    infoPengiriman: true
  });

  function clear(type) {
    setErrors({});
    setHidePw(true);
    setDisable((old) => ({ ...old, [type]: true }));
  }

  const handleSave = async (type = "infoAkun") => {
    try {
      if (type === "infoAkun") {
        if (forms?.password?.length < 8) {
          handleChangeError("password")(
            "Password must be at least 8 characters"
          );
          return;
        }
      }
      if (type === "infoPengiriman") {
        if (
          !phone(
            !forms?.telephone_store?.startsWith("+")
              ? `+${forms?.telephone_store}`
              : forms?.telephone_store
          )?.isValid
        ) {
          handleChangeError("telephone_store")("No Telephone tidak valid");
          return;
        }
      }
      const event = type === "infoAkun" ? "account" : "shipping";
      const coordinates =
        !profile?.address_information?.location?.latitude ||
        !profile?.address_information?.location?.longitude
          ? {
              latitude: 0,
              longitude: 0
            }
          : {
              latitude: profile?.address_information?.location?.latitude,
              longitude: profile?.address_information?.location?.longitude
            };

      const res = await updateProfileSaya({
        id: profile?.mitra_id,
        body: {
          ...forms,
          ...coordinates
        },
        event,
        token
      });
      if (!res.error) {
        clear(type);
        if (type == "infoAkun") {
          return showAlert({
            colors: "success",
            title: "Konfirmasi",
            desc: "berhasil di update, Apakah anda ingin mencoba login kembali?",
            descBold: "informasi pribadi!",
            handleClick: {
              open: {
                onClick: () => {
                  signOut();
                },
                text: "Logout",
                hide: false
              },
              close: {
                onClick: () => {},
                text: "tetap di halaman ini!",
                hide: false
              }
            }
          });
        }
        revalidateCustom({
          path
        })
        return toast.success(`Success melakukan update ${type}`, {
          position: "top-center"
        });
      } else {
        if (
          res.error.message.includes(
            "Sorry, requests to change personal information data can no longer be done, please contact CS"
          )
        ) throw new Error(res.error.message ?? res.error);
        
        handleErrorAPI(res.error, setErrors, [
          "email",
          "password",
          "name_store",
          "telephone_store"
        ]);
      }
    } catch (error) {
      toast.error(error.message, {position:"top-center"})
    }
  };

  const listFormAkun = [
    {
      key: "email",
      fieldDB: "email",
      label: "Email",
      typeInput: "text",
      disable: true
    },
    {
      key: "password",
      fieldDB: "password",
      placeholder: "*********",
      label: "Password",
      typeInput: hidePw ? "password" : "text",
      handleIcon: {
        right: (props) =>
          hidePw ? <EyeOffSvg {...props} /> : <EyeOnSvg {...props} />,
        onClickRight: () => setHidePw(!hidePw)
      }
    }
  ];

  const listFormPengiriman = [
    {
      key: "name_store",
      fieldDB: "name_store",
      label: "Nama Dropshipper",
      typeInput: "text",
      disable: profile?.mitra_level == 1 || disable?.infoPengiriman
    },
    {
      key: "telephone_store",
      fieldDB: "telephone_store",
      label: "No. HP",
      typeInput: "text",
      disable: disable?.infoPengiriman
    }
  ];

  return (
    <div className="flex md:flex-row flex-col gap-4">
      <div className="flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 gap-4 xs:p-8 xs:gap-8">
        <div className="flex flex-col xs:flex-row gap-4 justify-between">
          <p className="subheading-semiBold text-greyscaleGON-400">
            Informasi Pribadi
          </p>
          {disable?.infoAkun ? (
            <Button
              label="ubah"
              icon={{
                left: (props) => <PenEditSvg className={props.className} />
              }}
              size="small"
              variants="outline"
              onClick={() => setDisable((old) => ({ ...old, infoAkun: false }))}
            />
          ) : (
            <div className="flex flex-col-reverse xs:flex-row gap-4  items-center">
              <Button
                label="batal"
                size="small"
                variants="outline"
                onClick={() => clear("infoAkun")}
                className="flex w-full xs:w-auto"
              />
              <Button
                label="simpan"
                size="small"
                onClick={() => handleSave("infoAkun")}
                className="flex w-full xs:w-auto"
              />
            </div>
          )}
        </div>
        <div className="relative flex flex-col gap-4">
          {listFormAkun?.map((item, index) => (
            <React.Fragment key={index}>
              <Input
                onSubmit={() => handleSave("infoAkun")}
                onChange={handleChange(item?.key)}
                value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
                disabled={item?.disable ?? disable?.infoAkun}
                placeholder={item?.placeholder ?? profile?.[item?.fieldDB]}
                label={item?.label}
                error={!errors?.[item?.key] ? false : true}
                caption={errors?.[item?.key]}
                type={item?.typeInput}
                icon={item?.handleIcon}
              />
            </React.Fragment>
          ))}
        </div>
      </div>

      {profile?.mitra_level < 5 && (
        <div className="flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 gap-4 xs:p-8 xs:gap-8">
          <div className="flex flex-col xs:flex-row gap-4 justify-between">
            <p className="subheading-semiBold text-greyscaleGON-400">
              Informasi Pengiriman
            </p>
            {disable?.infoPengiriman ? (
              <Button
                label="ubah"
                icon={{
                  left: (props) => <PenEditSvg className={props.className} />
                }}
                size="small"
                variants="outline"
                onClick={() =>
                  setDisable((old) => ({ ...old, infoPengiriman: false }))
                }
              />
            ) : (
              <div className="flex flex-col-reverse xs:flex-row gap-4 items-center">
                <Button
                  label="batal"
                  size="small"
                  variants="outline"
                  onClick={() => clear("infoPengiriman")}
                  className="flex w-full xs:w-auto"
                />
                <Button
                  label="simpan"
                  size="small"
                  onClick={() => handleSave("infoPengiriman")}
                  className="flex w-full xs:w-auto"
                />
              </div>
            )}
          </div>
          <div className="relative flex flex-col gap-4">
            {listFormPengiriman?.map((item, index) => (
              <React.Fragment key={index}>
                <Input
                  onSubmit={() => handleSave("infoPengiriman")}
                  onChange={handleChange(item?.key)}
                  value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
                  disabled={item?.disable ?? disable?.infoPengiriman}
                  placeholder={item?.placeholder ?? profile?.[item?.fieldDB]}
                  label={item?.label}
                  error={
                    (!errors?.[item?.key] ? false : true) ||
                    (!forms?.[item?.key] && item?.key !== "mitra_level")
                  }
                  caption={
                    errors?.[item?.key] ||
                    (!forms?.[item?.key] && item?.key !== "mitra_level")
                      ? errors?.[item?.key] ?? "data not found"
                      : ""
                  }
                  type={item?.typeInput}
                  icon={item?.handleIcon}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
